module.exports = __webpack_public_path__ + "static/media/filled_bar_AERO_hand_tall.334885ea.svg";